import {GovFormControl, GovFormGroup, GovFormInput, GovFormLabel, GovFormMessage} from "@gov-design-system-ce/react";
import dayjs from "dayjs";
import {DateTimeFormatter} from "../DateTimeFormatter";

export interface DateFieldProps {
    value?: Date;
    readOnly?: boolean;
    prefix?: string;
    suffix?: string;
    message?: string;
    label?: string;
    placeholder?: string;
    onChange?: (value: Date | undefined) => void;
}

export default function DateField(props: DateFieldProps) {
    const {value, readOnly, message, label, placeholder, onChange} = props;

    function toDate(dateString: string | undefined): Date | undefined {

        if (!dateString) {
            return undefined;
        }

        return DateTimeFormatter.convertFromIsoDateTimeString(dateString);
    }

    return (
        <GovFormControl>
            <div>
                {label && <GovFormLabel slot="top" size="l">
                    {label}
                </GovFormLabel>}
                <GovFormGroup>
                    <GovFormInput size="m" variant="secondary" input-type="date"
                                  value={formatDate(value)}
                                  disabled={readOnly}
                                  placeholder={placeholder}
                                  onGov-input={(e) => onChange && onChange(toDate(e.detail.value))}
                    />
                </GovFormGroup>

                {message && <GovFormMessage slot={"bottom"} variant={"secondary"}>
                    {message}
                </GovFormMessage>}
            </div>
        </GovFormControl>
    );

    /*
        GovFromInput requires date in the format 'YYYY-MM-DD'
     */
    function formatDate(date: Date | undefined): string | undefined {
        if (!date) {
            return undefined;
        }
        return dayjs(date).format('YYYY-MM-DD');
    }

}